// extracted by mini-css-extract-plugin
export default {"countryOptionLabel":"fbCywuct","countryFlag":"SYAwCLih","TelephoneTextboxBody":"HGrZ4_Jm","countryNameAndCode":"cR_hwP6L","countrySelector":"lmL7xlb8","invalid":"vA2LgjRn"};